// components/ui/NotFoundContent.tsx

import * as Icons from "lucide-react";
import { useNavigate } from "react-router-dom";

interface NotFoundContentProps {
    iconName: string;
    title: string;
    description: string;
    actionLabel: string;
    actionHref: string;
}

export function NotFoundContent({
    iconName,
    title,
    description,
    actionLabel,
    actionHref
}: NotFoundContentProps) {
    const navigate = useNavigate();

    // Récupérer l'icône dynamiquement
    const Icon = (Icons as any)[iconName];

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center px-4">
            <div className="text-center max-w-2xl">
                <div className="w-24 h-24 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    {Icon && <Icon className="w-12 h-12 text-primary" />}
                </div>

                <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
                    {title}
                </h1>

                <p className="text-gray-500 mb-8">
                    {description}
                </p>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
                    >
                        <Icons.ArrowLeft className="w-4 h-4" />
                    </button>

                    <button
                        onClick={() => navigate(actionHref)}
                        className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 transition-colors"
                    >
                        {actionLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}